import './ohlc_values_in_list';
import './read_ohlc_obj';
import './is_candle_black';



// WEBPACK FOOTER //
// ./src/botPage/view/blockly/blocks/tools/candle/index.js